<div class="tvd-bucket box-border-bg" *ngIf="showMetricConfirmationBox()">

    <icon-delete
    (click)="removeItem(units,title)"
    topPosition="12"
    >
    </icon-delete>


    <table style="width: 100%; height: 100%;">
        <tr>
            <td colspan="3">
                <div class="tvd-bucket-cost">{{currencyCode | currencySymbol}}{{data.monetaryContribution}}</div>
            </td>
        </tr>
        <tr>
            <td colspan="3">
                <div class="tvd-bucket-data">{{data.valueContribution}}</div>
                <div class="tvd-bucket-units" >{{units}}</div>
            </td>
        </tr>
        <tr style="height:50%; vertical-align: center;">
            <td style="width: 20px;"></td>
            <td style="width: 7%; text-align: right;">
                <div style="display: inline-flex; margin-top: 8px;">
                    <img src="{{pngPath}}" class="tvd-gray-icon" *ngIf="id!='tvd-overall'">
                </div>
            </td>
            <td style="text-align: left;">
                <div style="display: inline-flex; width: 100%">
                    <div class="tvd-bucket-title" style="text-align: center; width: 70%">{{title}}</div>
                </div>
            </td>
        </tr>

    </table>
</div>
